import { render, staticRenderFns } from "./ProjectGroupDetails.vue?vue&type=template&id=2ede9ea8&"
import script from "./ProjectGroupDetails.vue?vue&type=script&lang=ts&"
export * from "./ProjectGroupDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports